import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormArray, FormControl } from '@angular/forms';

@Component({
  selector: 'app-institution-form',
  templateUrl: './institution-form.component.html',
  styleUrls: ['./institution-form.component.scss', '../detalhe.component.scss']
})
export class InstitutionFormComponent {
  @Input() instituicaoForm!: FormGroup;
  @Input() nomeInstituicaoFiltrado: any[] = [];
  @Input() cnesFiltrado: any[] = [];
  @Input() isSmartCase!: boolean;
  @Input() isVisibleEnderecoinstituicao!: boolean;

  @Output() validarEntrada = new EventEmitter<void>();

  constructor() {}
  
  ngOnInit(): void {
    console.log('INSTITUIÇÃO FORM:');
    console.log(this.instituicaoForm);
    console.log(this.instituicaoForm.get('telefone'));
  }

  // Getters para FormArray
  get telefoneArray(): FormArray {
    return this.instituicaoForm.get('telefone') as FormArray;
  }

  // Métodos adicionar/remover
  addTelefone() {
    if (this.telefoneArray.length < 2) {
      this.telefoneArray.push(new FormControl(''));
    }
  }

  removeTelefone(index: number) {
    if (this.telefoneArray.length > 0) {
      this.telefoneArray.removeAt(index);
    }
  }
}
